<script>
export let params = {}


let list=[];
let loading=false;

import feathers from '../web_feathers.js';
const rest = feathers.service('email');

async function refreshLookup(){
	console.log(params.email);
	loading=true;
	list = await rest.find({query:{$sort:{createdAt: -1}, to: {$ilike: '%'+params.email+'%'}}});
	loading=false;
	}
$: refreshLookup(params.email);

import displayDate from '../web_display_date.js';
//import {formatDistance} from 'date-fns';
//<th>altText</th>
const _MS_PER_DAY = 1000 * 60 * 60 * 24;
function dateDiffInDays(date) {
	if(!date) return '';
	date = new Date(date);
	var now = new Date();
	const utc1 = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
	const utc2 = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
	const age = Math.floor((utc2 - utc1) / _MS_PER_DAY);
	if(age>0) return 'in ' + age + ' days';
	else return age + ' days ago';
	}

</script>

<main>

<table border=1 class="container">
<tr><td colspan=2>{list.length} Email{#if list.length!=1}s{/if} sent to {params.email}</td></tr>
<tr>
<th>Info</th>
<th>Message</th>

</tr>
{#each list as email (email.id)}
	<tr>
	<td class="align-baseline">
		{displayDate(email.createdAt)} ({dateDiffInDays(email.createdAt)})<br>
		{#if email.environment!="freedomhot"}TESTING: {email.environment}<br>{/if}
		From: {email.from}<br>
		{#if email.to}	To: {email.to}<br>{/if}
		{#if email.cc}	CC: {email.cc}<br>{/if}
		{#if email.bcc}	BCC: {email.bcc}<br>{/if}
		</td>
	<td><b><u>{email.subject}</u></b><br>{@html email.message||email.altText.replace(/\n/g,'<br>')}</td>
	</tr>
{/each}
</table>

</main>